import PropTypes from 'prop-types'
import {
  TableCell,
  TableRow,
  FormControl,
  Autocomplete,
  IconButton,
  TextField,
  InputAdornment,
  FormHelperText,
  Grid,
} from '@mui/material'
import { Edit } from '@mui/icons-material'
import FormikSelect from '../FormikSelect'
import makeStyles from '@mui/styles/makeStyles'
import ExaminationRowActions from './ExaminationRowActions'
import { useState } from 'react'

const useStyles = makeStyles(() => ({
  cellSt: {
    width: '30%',
  },
  cellNd: {
    width: '20%',
  },
  cellTh: {
    width: '10%',
  },
  cellFinalizeLess: {
    width: '40%',
  },
  cellFull: {
    width: 'auto',
  },
}))

const getDisplayValue = (id, options) => {
  if (id) {
    for (let i = 0; i < options.length; i++) {
      let option = options[i]
      if (option.id == id) {
        return option.name
      }
    }
  } else {
    return null
  }
}

const ExaminationRowT3 = ({
  examinations,
  keyString,
  handleChange,
  assignFile,
  deleteRow,
  editFile,
  formik,
  finalize,
  edit,
  internal,
  files,
}) => {
  const classes = useStyles()
  const row = formik.values.examinations[3][keyString]
  const [id] = useState(row.id || Math.random())

  return (
    <TableRow>
      <TableCell
        className={finalize ? classes.cellSt : classes.cellFinalizeLess}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          {examinations && (
            <>
              {/* {finalize && (
                <Grid item xs={1}>
                  <Checkbox
                    className="toEvent"
                    color="primary"
                    inputProps={{
                      title: 'Stwórz zdarzenie na podstawie tego badania',
                    }}
                    checked={Boolean(
                      row.toEvent
                    )}
                    onChange={(e) => {
                      handleChange(e.target.checked, 'toEvent', 3, keyString)
                    }}
                  />
                </Grid>
              )} */}
              <FormControl
                fullWidth
                error={formik.touched.examinations && !row.examination_id}
              >
                <Autocomplete
                  value={
                    row.examination_id
                      ? getDisplayValue(row.examination_id, examinations)
                      : ''
                  }
                  disabled={finalize || (edit && parseInt(keyString) > 0)}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  onChange={(e, v) =>
                    handleChange(v.id, 'examination_id', 3, keyString)
                  }
                  id={`3-examination_id-${id}`}
                  name={`3-examination_id-${id}`}
                  variant="outlined"
                  options={examinations.map((option) => ({
                    id: option.id,
                    label: option.name,
                  }))}
                  renderInput={(props) => <TextField {...props} />}
                />
                {formik.touched.examinations && !row.examination_id && (
                  <FormHelperText>Wybierz Badanie</FormHelperText>
                )}
              </FormControl>
            </>
          )}
        </Grid>
      </TableCell>
      <TableCell
        className={finalize ? classes.cellTh : classes.cellFull}
        align="right"
      >
        <FormControl fullWidth>
          <TextField
            disabled={
              finalize ||
              (formik.values.status_id && formik.values.status_id != 1)
            }
            value={row.tooth1 || ''}
            error={
              formik.touched.examinations &&
              row.tooth1 &&
              !/^([1-8][1-9])((,[1-8][1-9])*)?$/.test(row.tooth1)
            }
            helperText={
              formik.touched.examinations &&
              row.tooth1 &&
              !/^([1-8][1-9])((,[1-8][1-9])*)?$/.test(row.tooth1) &&
              'numer zęba musi być poprawny'
            }
            id={`3-tooth1-${id}`}
            name={`3-tooth1-${id}`}
            onChange={(e) =>
              handleChange(e.target.value, 'tooth1', 3, keyString)
            }
          />
        </FormControl>
      </TableCell>
      <TableCell className={finalize ? classes.cellNd : classes.cellFull}>
        <FormControl fullWidth>
          <TextField
            disabled={formik.values.status_id && formik.values.status_id != 1}
            value={row.dap || ''}
            type="number"
            error={
              formik.touched.examinations &&
              ((row.dap <= 0 && !!row.dap) || (!row.dap && finalize))
            }
            helperText={
              formik.touched.examinations &&
              ((row.dap <= 0 && !!row.dap) || (!row.dap && finalize)) &&
              'Wartość musi być dodatnia'
            }
            id={`3-dap-${id}`}
            name={`3-dap-${id}`}
            onChange={(e) => handleChange(e.target.value, 'dap', 3, keyString)}
          />
        </FormControl>
      </TableCell>
      <TableCell className={finalize ? classes.cellTh : classes.cellFull}>
        <FormControl fullWidth>
          <TextField
            disabled={
              finalize ||
              (formik.values.status_id && formik.values.status_id != 1)
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">zł</InputAdornment>
              ),
            }}
            error={
              formik.touched.examinations &&
              !internal &&
              (row.price_gross <= 0 || !row.price_gross)
            }
            helperText={
              formik.touched.examinations &&
              !internal &&
              (row.price_gross <= 0 || !row.price_gross) &&
              'Wartość musi być dodatnia'
            }
            value={row.price_gross || ''}
            type="number"
            id={`3-price_gross-${id}`}
            name={`3-price_gross-${id}`}
            onChange={(e) =>
              handleChange(e.target.value, 'price_gross', 3, keyString)
            }
          />
        </FormControl>
      </TableCell>
      {finalize && (
        <TableCell className={finalize ? classes.cellSt : classes.cellFull}>
          <FormControl fullWidth>
            <FormikSelect
              variableName="romexis_id"
              disabled={row && row.disabled_romexis}
              value={row.romexis_id || null}
              forceError={formik.touched.examinations && !row.romexis_id}
              labelName="Zdjęcie"
              noOptionsText={
                files && files.length > 0 ? null : 'Synchronizacja zdjęć...'
              }
              forceHelperText={
                formik.touched.examinations && !row.romexis_id
                  ? 'Proszę wybrać zdjęcie'
                  : ''
              }
              handleChange={assignFile}
              formik={formik}
              config={{
                key: 'romexis_id',
                label: 'name+dap',
                separator: ' - ',
              }}
              options={files}
            />
          </FormControl>
        </TableCell>
      )}
      {edit && formik.values.status_id && formik.values.status_id != 1 && (
        <TableCell>
          <span>{(row && row.photo_name) || 'Brak zdjęcia'}</span>
          <IconButton
            // color="secondary"
            component="span"
            onClick={() => editFile(3, keyString)}
            size="large"
          >
            <Edit />
          </IconButton>
        </TableCell>
      )}
      {!finalize && !(formik.values.status_id && formik.values.status_id != 1) && (
        <TableCell>
          <ExaminationRowActions
            deleteRow={() => deleteRow(3, keyString)}
            row={{
              comment: row.comment,
              id,
            }}
            setComment={(comment) => {
              handleChange(comment, 'comment', 3, keyString)
            }}
          />
        </TableCell>
      )}
    </TableRow>
  )
}

ExaminationRowT3.propTypes = {
  examinations: PropTypes.array,
  formik: PropTypes.object,
  handleChange: PropTypes.func,
  assignFile: PropTypes.func,
  deleteRow: PropTypes.func,
  editFile: PropTypes.func,
  keyString: PropTypes.string,
  finalize: PropTypes.bool,
  edit: PropTypes.bool,
  internal: PropTypes.bool,
  files: PropTypes.array,
}

export default ExaminationRowT3
